 import React from "react";

const Footer = () => {
  var d = new Date();
  return (
    <>
      <div className="footer">
        <div className="copyright">
          <p>
            Copyright © Designed &amp; Developed By Khelo Tech and Strategy Privated Limited.


            {d.getFullYear()}
          </p>
        </div>
      </div>

      {/* Phone view only: bottom bar with the PWA scanner (logs in there first if needed) */}
      <div className="d-md-none" style={{ height: 64 }} />
      <nav
        className="d-md-none fixed-bottom bg-white border-top d-flex justify-content-around align-items-center"
        style={{ zIndex: 1030, paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <a href="/scanner" className="d-flex flex-column align-items-center text-primary text-decoration-none py-2 px-4">
          <i className="fa fa-qrcode fs-4" />
          <small className="fw-bold">Scanner (PWA)</small>
        </a>
      </nav>
    </>
  );
};

export default Footer;
